import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { headUrl } from '../lib/minecraft.js';
import '../styles/components/CategoryStyle.css';

export function CategoryNav() {
  const { categories } = useStoreConfig();
  const [isExpanded, setExpanded] = useState(false);

  return (
    <nav className={`category-dropdown${isExpanded ? ' category-dropdown--expanded' : ''}`}>
      <button
        type="button"
        className="category-dropdown-trigger"
        aria-expanded={isExpanded}
        onClick={() => setExpanded((expanded) => !expanded)}
      >
        <i className="fa-solid fa-bars-staggered" />
        <span className="category-dropdown-label">Browse store</span>
        <i className="fa-solid fa-chevron-down category-dropdown-chevron" aria-hidden="true" />
      </button>

      <div className="category-dropdown-content">
        <aside className="category">
          <h3 className="category-title">
            <i className="fa-solid fa-bag-shopping" /> Start shopping
          </h3>

          <NavLink
            to="/home/"
            className={({ isActive }) =>
              `category-item category-item--home${isActive ? ' active' : ''}`
            }
          >
            <span className="category-icon">
              <i className="fa-solid fa-house" />
            </span>
            <span className="category-text">Home</span>
            <i className="fa-solid fa-chevron-right category-arrow" />
          </NavLink>

          {categories.map((category) => (
            <NavLink
              key={category.id}
              to={`/categories/${category.slug}/`}
              className={({ isActive }) => `category-item${isActive ? ' active' : ''}`}
            >
              {category.icon ? (
                <img
                  src={headUrl(category.icon, 80)}
                  alt=""
                  width="38"
                  height="38"
                  loading="eager"
                  fetchPriority="high"
                  decoding="async"
                />
              ) : (
                <span className="category-icon">
                  <i className="fa-solid fa-cube" />
                </span>
              )}
              <span className="category-text">{category.name}</span>
              <i className="fa-solid fa-chevron-right category-arrow" />
            </NavLink>
          ))}
        </aside>
      </div>
    </nav>
  );
}
